/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

export const useFormStyles = makeStyles((theme: Theme) => ({
  formControl: {
    display: 'flex',
    '&$formControlBlock': {
      display: 'block',
    },
    marginTop: '20px',
    '&:not($firstKeepOffset):first-child': {
      marginTop: 0,
    },

    '& .MuiFormHelperText-root': {
      fontSize: '12px',
      lineHeight: '16px',
      padding: '0 16px',
    },
    '& .MuiFormHelperText-contained': {
      marginLeft: '0',
      marginRight: '0',
    },
    '&$noOffset': {
      marginTop: '0px',
      '&:first-child:not($firstKeepOffset)': {
        marginTop: 0,
      },
    },
    '&$smallOffset': {
      marginTop: '5px',
      '&:first-child:not($firstKeepOffset)': {
        marginTop: 0,
      },
    },
  },
  formControlBlock: {},
  noOffset: {},
  smallOffset: {},
  firstKeepOffset: {},
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  widthDefault: {
    maxWidth: '240px',
    width: '100%',
  },
  widthMedium: {
    maxWidth: '620px',
    width: '100%',
  },
  widthFull: {
    maxWidth: '100%',
    width: '100%',
  },
  checkboxes: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '20px',
  },
  hiddenSubmitBtn: {
    display: 'none',
  },
}));
